module.exports = __webpack_public_path__ + "static/img/round4-finish-2x.c05f4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/financialCompetition/round4-finish-2x.png
// module id = wa6U
// module chunks = 86